import React from 'react';
import IOrder from 'types/backend_models/orders/IOrder';
import ContainerSectionTitle from 'components/content/shared/other/ContainerSectionTitle';
import BasicField from 'components/content/shared/fields/BasicField';
import { toDateString } from 'functions/formatters/date';


interface IProps
{
	order: IOrder | null
}

const labelClassName = "col-m-6";
const valueClassName = "col-m-6";

function OrderDetailInfo(props: IProps)
{
	// console.log(colors);

	if (!props.order) {
		return null;
	} else {
		// const statusColor = GetOrderStatusColor(props.order.statusId);

		return (
			<>
				<ContainerSectionTitle>Order Info</ContainerSectionTitle>
				<BasicField
					label="Order Number"
					value={props.order.orderNumber}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Your Reference"
					value={props.order.customerReference}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				{/* <BasicField
					label="Ordered by"
					value={props.order.orderedBy}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/> */}
				<BasicField
					label="Order Date"
					value={toDateString(props.order.orderDate)}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Shipping Date"
					value={toDateString(props.order.shippingDate)}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				<BasicField
					label="Payment Condition"
					value={props.order.paymentCondition}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
				{/* <BasicField
					label="Status"
					value={props.order.status}
					valueStyle={{ color: `${statusColor}` }}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/> */}
				<BasicField
					label="Incoterm"
					value={props.order.incoTerm}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
					/>
				<BasicField
					label="Incoterm Location"
					value={props.order.incoTermLocation}
					labelColumnClassName={labelClassName}
					valueColumnClassName={valueClassName}
				/>
			</>
		);
	}
};

export default OrderDetailInfo;